import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

async function normalizarParaSalvar(provisoes) {

  var provisoesSelecionadas = "";

  for (var i = 0; i < provisoes.length; i++) {
    if (provisoes[i].selecionado == "1") {
      provisoesSelecionadas += provisoes[i].idProvisaoCrypt + ";";
    }
  }

  return provisoesSelecionadas;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/liberarprovisoespagamento', { params: parametros }).then(response => response.data);
  },
  liberarProvisoes: async (provisoes) => {
    provisoes = await normalizarParaSalvar(provisoes);

    return Vue.http.put(`/api/liberarprovisoespagamento/${provisoes}/liberarprovisoes`).then(res => res.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-provisoes-pagamento/servico.js